import type { Group } from '@anov/3d-core'

export type TextOption = Partial<{
  visible: boolean
  value: string
  fontSize: number
  color: string
  fontWeight: string
  offset: [number, number]
  bgUrl: string
  slice: [number, number, number, number]
  hueRotate: number
  uri: string
}>

export type ModelOption = Partial<{
  visible: boolean
  uri: string
  color: string
}>

export type ParticleOption = Partial<{
  visible: boolean
  uri: string
  radius: number
  color: string
}>

export type Option = Partial<{
  facingCamera: boolean
  autoScale: boolean
  style: string
  text: TextOption
  model: ModelOption
  particle: ParticleOption
  content: TextOption
}>

export interface IPoi {

  mesh: Group
  facingCamera: boolean
  autoScale: boolean

  destroy()

}